<template>
  <div class="popup-container">
    <SharePopup :showSharePopup="appStore.showSharePopup"></SharePopup>

    <ImportPopup :showImportPopup="appStore.showImportPopup"></ImportPopup>
    <WelcomeVideoPopup
      :showWelcomeVideoPopup="appStore.showWelcomeVideoPopup"
    ></WelcomeVideoPopup>
    <AdvancedExportModal
      :showAdvancedExportPopup="appStore.showAdvancedExportPopup"
    ></AdvancedExportModal>
    <DeleteAccountPopupVue
      :showDeleteAccountPopup="appStore.showDeleteAccountPopup"
    >
    </DeleteAccountPopupVue>
    <NewWorkspacePopup
      :showNewWorkspacePopup="appStore.showNewWorkspacePopup"
    ></NewWorkspacePopup>
    <RecordingPopup
      :showRecordingPopup="appStore.showRecordingPopup"
    ></RecordingPopup>
    <NotificationOptInPopup></NotificationOptInPopup>
    <InAppMessageModal v-if="inappMessagingEnabled"></InAppMessageModal>
    <div class="popup-holder search-tab" style="display: none">
      <div class="speaker-drop">
        <div class="speaker-scroll">
          <div class="speaker_top-bar">
            <div class="speaker_nav-bar">
              <ul class="speaker-switch">
                <li class="active">
                  <a href="#ai-notes01">Ai Notes</a>
                </li>
                <li>
                  <a href="#answers01">Answers</a>
                </li>
              </ul>
              <a href="#" class="speaker_return icon-to-left"></a>
            </div>
            <form action="#" class="search-form reply-form">
              <div class="search_input-wrap">
                <input
                  type="text"
                  id="pain-points"
                  name="pain-points"
                  placeholder="Ask a question about this conversation"
                  aria-label="Ask a question about this conversation"
                />
                <button
                  type="submit"
                  class="search-icon icon-right-arrow"
                ></button>
              </div>
              <a href="#" class="search_close-icon icon-close"></a>
            </form>
          </div>
          <div class="speaker-drop_content">
            <div class="speaker-switch_tab tab-active" id="ai-notes01">
              <div class="ai-list_title">
                <span class="list-icon icon-bot"></span>
                <span class="title-txt">Ai-powered Notes:</span>
              </div>
              <ul>
                <li>
                  Lorem ipsum dolor sit amet consectetur. At hac id vel bibendum
                  proin phasellus habitant. Condimentum id malesuada amet vitae
                  donec mi odio in.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur. At hac id vel bibendum
                  proin phasellus habitant. Condimentum id malesuada amet vitae
                  donec mi odio in.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur. At hac id vel bibendum
                  proin phasellus habitant. Condimentum id malesuada amet vitae
                  donec mi odio in.
                </li>
              </ul>
            </div>
            <div class="speaker-switch_tab" id="answers01">
              <div class="ai-list_title">
                <span class="list-icon icon-bot"></span>
                <span class="title-txt">Ai-powered Notes:</span>
              </div>
              <ul>
                <li>
                  Lorem ipsum dolor sit amet consectetur. At hac id vel bibendum
                  proin phasellus habitant. Condimentum id malesuada amet vitae
                  donec mi odio in.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur. At hac id vel bibendum
                  proin phasellus habitant. Condimentum id malesuada amet vitae
                  donec mi odio in.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur. At hac id vel bibendum
                  proin phasellus habitant. Condimentum id malesuada amet vitae
                  donec mi odio in.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAppStore } from "@/stores/app-store";
import { useNotificationStore } from "@/stores/notification-store";
import { mapStores } from "pinia";

import ImportPopup from "@/components/popups/ImportPopup.vue";
import WelcomeVideoPopup from "@/components/popups/WelcomeVideoPopup.vue";
import AdvancedExportModal from "@/components/popups/AdvancedExportModal.vue";
import DeleteAccountPopupVue from "@/components/popups/DeleteAccountPopup.vue";
import NewWorkspacePopup from "./popups/NewWorkspacePopup.vue";
import SharePopup from "@/components/popups/SharePopup.vue";
import RecordingPopup from "@/components/popups/RecordingPopup.vue";
import NotificationOptInPopup from "@/components/popups/NotificationOptInPopup.vue";
import InAppMessageModal from "@/components/popups/InAppMessageModal.vue";
import { isInAppMessagingEnabled } from "@/services/inapp.service";

export default {
  name: "PopupContainer",
  components: {
    ImportPopup,
    WelcomeVideoPopup,
    AdvancedExportModal,
    DeleteAccountPopupVue,
    NewWorkspacePopup,
    SharePopup,
    RecordingPopup,
    NotificationOptInPopup,
    InAppMessageModal,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapStores(useAppStore, useNotificationStore),
    // IN_APP engagement modal: fully dormant (not even mounted) without VITE_ENGAGEMENT_API_URL
    inappMessagingEnabled() {
      return isInAppMessagingEnabled();
    },
    // importPopupDisplay: function() {

    // },
  },
  methods: {},
};
</script>
